// extracted by mini-css-extract-plugin
module.exports = {"investmentBody":"InvestmentBody_investmentBody__3K2jO","offeringValidError":"InvestmentBody_offeringValidError__1kS_V"};